import { store } from '@/store/index'

export default async(to, from, next) => {
  const auth_data = JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_auth_data'))
  let valid = true
  if (auth_data === undefined || !auth_data) {
    await store.dispatch('remove_token')
    valid = await store.dispatch('fetchToken')
  }
  if (!valid) {
    next({ name: '_store_is_not_available' })
  } else {
    if (store.getters.selectedStore === undefined || !store.getters.selectedStore) {
      const selected_store = store.state.selected_store
      if (selected_store === null || selected_store === undefined) {
        await store.dispatch('fetchStore')
        const outlet_id = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_selected_id')
        if (outlet_id) {
          const obj = {
            id: Number(outlet_id)
          }
          await store.dispatch('fetchOutlet', obj)
        } else {
          store.dispatch('saveSelectedId', store.state.selected_store.id)
          const obj = {
            id: Number(store.state.selected_store.id)
          }
          await store.dispatch('fetchOutlet', obj)
        }
      }
    }
  }
}
